import { useQuery } from "@tanstack/react-query";
import {
  ApiError,
  ApiServiceError,
  GetListRequestParams,
  GetListResponse
} from "libs/api";
import { QueryOptions } from "libs/reactQuery";

import { IRefund } from "../../financial.types";
import { requestRefunds } from "./refunds.request";

const useRefunds = (
  requestParams: GetListRequestParams,
  options?: QueryOptions<GetListResponse<IRefund>, ApiServiceError<ApiError>>
) => {
  const { data, ...rest } = useQuery({
    queryKey: ["refunds", requestParams],
    queryFn: async () => await requestRefunds(requestParams),
    ...options
  });

  return { refunds: data?.data, meta: data?.meta, ...rest };
};

export default useRefunds;
